import React from 'react';
import { Card, Text } from '../../../component';
import { isSmartPhone } from '../../../utilities/helper';
import './index.css';
interface TeamPreviewPlayerHeaderProps {
  title?: any;
}

const TeamPreviewPlayerHeader = ({ title = '' }: TeamPreviewPlayerHeaderProps) => {
  return (
    <Card
      className={
        isSmartPhone
          ? 'team-preview-player-header-container_mWeb'
          : 'team-preview-player-header-container'
      }
      style={{ width: !isSmartPhone ? '350px' : '' }}>
      <Text
        className={
          isSmartPhone
            ? 'team-preview-player-header-title_mWeb'
            : 'team-preview-player-header-title'
        }>{`${title}`}</Text>
    </Card>
  );
};
export default React.memo(TeamPreviewPlayerHeader);
